import _ from 'lodash';
import moment from "moment";
import { MAIN_REDUX_STATE_KEY, mainCreators } from "../../actions/mainAction";
import { adController } from "../../apiService/apiController/adService";
import { authController } from '../../apiService/apiController/authService';
import { BASE_API, BASE_PORT_API } from '../../config/config';
import { ModelUserAuth } from '../../models/ModelUserAuth';
import { storeDispatch, storeGetState } from "../../stores";
import { LOCAL_STORAGE } from "../constants/localStorage";
import { firebaseUnsubscribeNoti } from "../firebases/firebaseNotification";
import { getCMSTncList } from "../services/cmsTnc";
import { getLocalStorage, removeLocalStorage, setLocalStorage } from "./localStorage";
import { isValidResponse } from "./validation";
import { toast } from '../../helpers/functions/main';
import { DATA_REDUX_STATE_KEY, dataCreators } from '../../actions/dataAction';
import { ModelMultipleLocationAccount } from '../../models/ModelAccount';
import { ROUTE_PATH } from '../constants/route';

export const getUserAuth = () => {
  if (!getCookie() && !getByPassCookie('tb.oauth.bypass')) {
    removeLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE);
    return false;
  }
  return getLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE);
}

export const setUserAuthRedux = (userAuth) => {
  storeDispatch(mainCreators.setMainRedux(MAIN_REDUX_STATE_KEY.USER_AUTH, userAuth));
}

export const getUserAuthRedux = () => {
  return storeGetState().mainRedux.userAuth;
}

export const loginMsal = (email) => {
  // if (email !== 'passthrough') {
  //   setLocalStorage(LOCAL_STORAGE.CURRENT_EMAIL, email);
  // }
  window.location.href = `${BASE_API}${BASE_PORT_API}/oauth/sign-in-url?email=${encodeURIComponent(email)}`;
}

export const handleOAuthCookie = async () => {
  if (getByPassCookie('tb.oauth.bypass')) {

    const authService = authController();
    const res = await authService.loginSearch();
    if (isValidResponse(res)) {
      const newUserAuth = new ModelUserAuth(res.data);
      setLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE, newUserAuth);
      setUserAuthRedux(newUserAuth);

      if (!isSameLocationAccount(newUserAuth.adRefId) && newUserAuth.multipleLogin) {
        setLocalStorage(LOCAL_STORAGE.SELECT_LOCATION_ACCOUNT, newUserAuth.adRefId);
        window.location.href = ROUTE_PATH.HOME.LINK;
      }

      return true;
    }
    return true;
  }

  if (getCookie()) {

    const authService = authController();
    const res = await authService.loginByCC();

    if (isValidResponse(res)) {
      const newUserAuth = new ModelUserAuth(res.data);
      setLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE, newUserAuth);
      setUserAuthRedux(newUserAuth);
      return true;
    }

    removeLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE);
    // removeLocalStorage(LOCAL_STORAGE.CURRENT_EMAIL);
    setLocalStorage('ERROR_LOGIN_MSG', res.message);
    authService.logoutCC();
    return false;
  } else {
    if (getLocalStorage('ERROR_LOGIN_MSG')) {
      toast.error(getLocalStorage('ERROR_LOGIN_MSG'));
      removeLocalStorage('ERROR_LOGIN_MSG');
      // removeLocalStorage(LOCAL_STORAGE.CURRENT_EMAIL);
    }
    removeLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE);
    return false;
  }
}

const getByPassCookie = (cookieName) => {
  const name = cookieName;
  let cookieValue;
  if (document.cookie && document.cookie !== '') {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const getCookie = () => {
  const name = 'tb.oauth.azure.token-used'
  let cookieValue;
  if (document.cookie && document.cookie !== '') {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export const logout = () => {
  removeLocalStorage(LOCAL_STORAGE.SELECT_LOCATION_ACCOUNT);
  firebaseUnsubscribeNoti();
  removeLocalStorage(LOCAL_STORAGE.USER_AUTH_RBPTRUEBLUE);
  window.location.href = `${BASE_API}${BASE_PORT_API}/oauth/sign-out-url`;
}

export const acceptTnC = async () => {
  const userAuth = getUserAuthRedux();
  const params = {
    sfid: userAuth.sfid,
    accept: true
  }
  const adService = adController();
  const res = await adService.updateTermsAndCondition(params);
  if (isValidResponse(res)) {
    return true;
  }
  return false
}

export const getAcceptTnc = async () => {
  const userAuth = getUserAuthRedux();
  if (userAuth.acceptTermsConditions) {
    return true;
  }
  else {
    const params = {
      page: 1,
      limit: 1,
      status: 'active',
      sort: 'id desc',
    };
    await getCMSTncList(params);
    return false;
  }
}

export const handleCheckMaintenance = () => {
  const maintenanceData = storeGetState().mainRedux.maintenance;
  if (maintenanceData.isMaintenance) {
    if (handleCheckMaintenanceWhiteList()) {
      return true
    }
    else {
      return false
    }
  }
  return true;
}

export const handleCheckMaintenanceWhiteList = () => {
  const maintenanceData = storeGetState().mainRedux.maintenance;
  const userAuth = getUserAuth();
  if (userAuth) {
    if (maintenanceData.userWhiteList.indexOf(userAuth.email) >= 0) {
      return true;
    } else {
      logout();
    }
  }
  return false;
}

// export const handleValidateAuth = () => {
//   const userAuth = getUserAuth();
//   if (userAuth) {
//     const dateNow = moment();
//     const currentDate = dateNow.format('YYYY-MM-DD');
//     const lastActiveDate = moment(getLocalStorage(LOCAL_STORAGE.LAST_ACTIVE_AT));
//     const diffDate = moment(currentDate).diff(lastActiveDate, 'days');
//     if (diffDate > 7) {
//       setLocalStorage(LOCAL_STORAGE.IS_TOAST_RE_LOGIN, true);
//       logout();
//       return false
//     } else {
//       setLocalStorage(LOCAL_STORAGE.LAST_ACTIVE_AT, currentDate);
//       return true
//     }
//   }
//   return true;
// }

export const isAccountSegmentPass = (data = '') => {
  const userAuth = getUserAuthRedux()
  const segmentCategory = JSON.parse(data || null)

  if (userAuth.segmentCategory__c === null && userAuth.segmentation__c === null) {
    return false
  }

  if (segmentCategory === null) {
    return true;
  }

  if (segmentCategory[userAuth.segmentCategory__c]) {
    if (userAuth.segmentation__c) {
      return segmentCategory[userAuth.segmentCategory__c][userAuth.segmentation__c];
    }
    return true
  }
  return false
}

export const isAccountAndCustomerPass = (accountData = '', customerData = '') => {
  const userAuth = getUserAuthRedux()
  const accountType = JSON.parse(accountData || null)
  const customerType = JSON.parse(customerData || null)

  if (userAuth.accountRoleType === '' || userAuth.customerRoleType === '') {
    return false
  }

  if (accountType === null && customerType === null) {
    return true;
  }

  let customerRoleType = userAuth.customerRoleType
  if (customerRoleType === 'Toko') {
    customerRoleType = 'Hardware Shop Toko'
  }

  if (accountType[userAuth.accountRoleType] && customerType[customerRoleType]) {
    return true
  }

  return false
}

export const getMultipleLocationList = async (params) => {
  const adService = adController();
  const res = await adService.getMultipleLocation();

  if (isValidResponse(res)) {
    const locationAccountList = res.data.map(e => new ModelMultipleLocationAccount(e))
    console.log('getMultipleLocationList', res.data, locationAccountList);
    return locationAccountList;
  }
  return []
}

export const updateSelectLocation = async (params) => {
  const adService = adController();
  const res = await adService.updateSelectLocation(params);

  if (isValidResponse(res)) {
    return res
  }
}

export const isSameLocationAccount = (currentLocationSfid) => {
  const locationAccountSelected = getLocalStorage(LOCAL_STORAGE.SELECT_LOCATION_ACCOUNT);
  if (!locationAccountSelected) {
    return true;
  }
  return locationAccountSelected === currentLocationSfid;
}

